import { render } from "./TableList.vue?vue&type=template&id=33bc3eb6&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=33bc3eb6&lang=scss&scoped=true"
import "./TableList.vue?vue&type=style&index=1&id=33bc3eb6&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc3eb6"]])

export default __exports__